<template>
  <tr>
    <td>{{ log.description }}</td>
    <td>{{ log.type }}</td>
    <td>{{ log.user ? log.user.name : '' }}</td>
    <td>{{ log.route }}</td>
    <td>
      <span
        :class="{
          'badge badge-success': log.response.status == 200,
          'badge badge-danger': log.response.status == 500,
          'badge badge-warning': (log.response.status !== 200 && log.response.status !== 500)
        }">
      {{ log.response.status }}
      </span>
    </td>
    <td>{{ log.method }}</td>
    <td>{{ log.application }}</td>
    <td>{{ log.created_at | dateParse("YYYY-MM-DD HH:mm:ss") | dateFormat("DD/MM/YYYY HH:mm:ss")}}</td>
    <td>
      <button
        class="btn btn-info btn-circle"
        v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
        title="Voir les détails"
        @click="view(log.id)"
      >
        <i class="fas fa-eye"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

import { FETCH_LOG } from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { P_READ_DEMAND } from "@/helpers/permissions";

export default {
  props: {
    log: { type: Object, required: true },
  },
  data() {
    return {
      P_READ_DEMAND,
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    view(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_LOG, id)
        .then(() => {
          //this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "log-view" });
        })
        .catch(() => {
          //this.$store.commit(SET_LOADING, false);
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
</style>